import { change } from 'redux-form';
import _ from 'lodash';

import * as types from './types';
import { loading, error } from 'State/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { WarehouseReportEnum } from 'Common/FieldEnum';

export const getPrintHold = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_WAREHOUSE_KITCHEN_HOLD_REPORTS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'WarehouseReports/GetPrintHold',
        printRequestData
      );
      if (_.has(response, 'data.Data.Data')) {
        ReportGeneration(
          response.data.Data.Data,
          "Warehouse/Kitchen Hold Report's"
        );
      }
    } catch (err) {
      dispatch(error(types.PRINT_LOADING_ERROR, err));
    } finally {
      dispatch(
        loading(types.PRINT_WAREHOUSE_KITCHEN_HOLD_REPORTS_LOADING, false)
      );
    }
  };
};

export const getPrintAvailability = printRequestData => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PRINT_WAREHOUSE_KITCHEN_AVAI_REPORTS_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'WarehouseReports/GetPrintAvailability',
        printRequestData
      );
      if (_.has(response, 'data.Data.Data')) {
        ReportGeneration(
          response.data.Data.Data,
          "Warehouse/Kitchen Availability Report's"
        );
      }
    } catch (err) {
      dispatch(error(types.PRINT_LOADING_ERROR, err));
    } finally {
      dispatch(
        loading(types.PRINT_WAREHOUSE_KITCHEN_AVAI_REPORTS_LOADING, false)
      );
    }
  };
};

export const setWarehouseKitchenValue = (warehouseValue, fromName) => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(
      change(fromName, WarehouseReportEnum.WarehouseKitchen, warehouseValue)
    );
  };
};
export const clearPrintLoadingError = () => {
  return {
    type: types.CLEAR_PRINT_LOADING_ERROR,
  };
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/state/actions.js